import { useEffect } from 'react';
import WebFont from 'webfontloader';
import { Skin, ThemeOption } from '../types/enums';
import { getThemeDefinition } from '../styles/themeConfig';

const GOOGLE_FONT_FAMILIES = new Set(['Lexend', 'Poppins', 'Sora', 'Manrope']);
const GOOGLE_FONT_WEIGHTS = '300,400,500,600,700,800';

const getPrimaryFontFamily = (fontFamily: string) => {
  return fontFamily
    .split(',')[0]
    .trim()
    .replace(/^['"]|['"]$/g, '');
};

export const useGoogleFonts = (skin: Skin, theme: ThemeOption) => {
  useEffect(() => {
    const { typography } = getThemeDefinition(skin, theme);
    const googleFonts = new Set<string>();

    const headingFamily = getPrimaryFontFamily(typography.h1.fontFamily);
    const bodyFamily = getPrimaryFontFamily(typography.body1.fontFamily);

    if (GOOGLE_FONT_FAMILIES.has(headingFamily)) {
      googleFonts.add(`${headingFamily}:${GOOGLE_FONT_WEIGHTS}`);
    }

    if (GOOGLE_FONT_FAMILIES.has(bodyFamily)) {
      googleFonts.add(`${bodyFamily}:${GOOGLE_FONT_WEIGHTS}`);
    }

    if (googleFonts.size > 0) {
      WebFont.load({
        google: {
          families: Array.from(googleFonts),
        },
      });
    }
  }, [skin, theme]);
};
